import React from "react";

const InnerUserMex = ({ text }) => {
    return (
        <div className="inner_user_cont">
            <p className="inner_user_mex">{text}</p>
            <div className="footer_inner_user_mex">
                <i>
                    {/* <BiPencil /> */}
                </i>
                <p style={{fontSize: "10px"}}>
                    Me
                </p>
            </div>
        </div>
    );
};

export default InnerUserMex